import React, { Fragment } from "react";
import { Table } from "react-bootstrap";
import { QUALIFICATION_TYPES } from "../../constants/constants";
import { getQualificationByID } from "../../util/helpers";

export const GraduationDetails = ({ qualificationDetails }) => {
  return (
    <Fragment>
      <h6 className="text-left">
        {getQualificationByID(qualificationDetails.qualificationId)}
      </h6>
      <div className="container mt-3">
        <div className="col report text-center">
          <Table striped bordered hover size="sm">
            <tr>
              <td align="left">
                <strong>Degree :</strong>
                {qualificationDetails.degree}
              </td>

              <td align="left" colSpan="2">
                <strong>Specialization :</strong>
                {qualificationDetails.specialization}
              </td>
            </tr>
            <tr>
              <td align="left">
                <strong>Completed Year : </strong>
                {qualificationDetails.completionYear}
              </td>
              <td align="left" colSpan="2">
                <strong>Percentage/Grade : </strong>
                {qualificationDetails.grade}
              </td>
            </tr>
            <tr>
              <td align="left">
                <strong>College : </strong>
                {qualificationDetails.college}
              </td>
              <td align="left">
                <strong>University : </strong>
                {qualificationDetails.university}
              </td>
              <td align="left">
                <strong>Location : </strong>
                {qualificationDetails.location}
              </td>
            </tr>
          </Table>
        </div>
      </div>
    </Fragment>
  );
};

export default GraduationDetails;
